// Don't format this file

import React, { useState } from 'react';
import enGb from 'date-fns/locale/en-GB';
import DatePicker, { registerLocale } from 'react-datepicker';
import Select from 'react-select';
import { getWeekNumber } from '../utils/utils';
import {
  addMyTimeSheetDetails,
  getMyTimeSheetDetails,
} from '../API';
import { toast } from 'react-toastify';
registerLocale('en-gb', enGb);

const AddNewTimeSheet = (props) => {
  const { refreshData, allCrews } = props;
  const [startDate, setStartDate] = useState();
  const [selectedOption, setSelectedOption] = useState();
  const [options, setOptions] = useState([]);

  const setWeekData = async (data) => {
    setStartDate(data);
    const weekNumber = getWeekNumber(data);
    if (weekNumber) {
      setSelectedOption({ label: '', value: '' });
      await getMyTimeSheetDetails(`week=${weekNumber}`).then((res) => {
        if (res?.status === 200) {
          const weeklyTimeSheetsData = res?.data;
          const crewDropDownOptions = allCrews
            ?.filter((ele) => {
              const findWeekCrew = weeklyTimeSheetsData?.find(
                (item) => item?.crew_id === ele?.id
              );
              if (ele?.id !== findWeekCrew?.crew_id) {
                return {
                  label: ele?.virtual_id,
                  value: ele?.id,
                };
              }
            })
            .map((ele) => ({
              label: ele.virtual_id,
              value: ele.id,
            }));
          setOptions(crewDropDownOptions);
        }
      });
    }
  };

  const onChangeCrewSelect = (value) => {
    setSelectedOption({ label: value?.label, value: value?.value });
  };


  const onClickSubmit = async () => {
    if (startDate && selectedOption?.value) {
      const weekNumber = getWeekNumber(startDate);
      const payload = {
        week: weekNumber,
        crew_id: selectedOption?.value,
        time_sheet_status_id: 0,
      };
      addMyTimeSheetDetails(payload)?.then((res) => {
        if (res?.status === 200) {
          refreshData();
          toast.success('Time Sheet Added Successfully');
        }
      });
    } else {
      toast.warning('Please enter the required fields');
    }
  };

  return (
    <>
      <div
        className='modal fade add-new-timesheet-modal'
        id='addNewTimeSheet'
        tabIndex='-1'
        aria-labelledby='addNewTimeSheetLabel'
        aria-hidden='true'
        data-bs-backdrop='static'
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5
                className='modal-title font-weight-bold'
                id='addNewTimeSheetLabel'
              >
                Add New Time Sheet
              </h5>
              <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => {
                  setStartDate('');
                  setSelectedOption({ label: '', value: '' });
                  setOptions([]);
                }}
              ></button>
            </div>
            <div className='offcanvas-body'>
              <div className='input-flex'>
                <label htmlFor='recipient-name' className='col-form-label'>
                  Week*
                </label>
                <div className='input-box'>
                  <DatePicker
                    className='input-field form-control w-100'
                    placeholderText='Select Week'
                    selected={startDate}
                    onChange={(date) => setWeekData(date)}
                    dateFormat='I/R'
                    locale='en-gb'
                    showWeekNumbers
                    showWeekPicker
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
                <div className='input-box'>
                  <label htmlFor='recipient-name' className='col-form-label'>
                    Select Crew*
                  </label>
                  <Select
                    // defaultInputValue={allSelectedUsers}
                    placeholder={'Select Crew'}
                    value={selectedOption}
                    className='react-select-container-members'
                    classNamePrefix='react-select'
                    name='colors'
                    options={options}
                    onChange={(item) => onChangeCrewSelect(item)}
                  />
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  data-bs-dismiss='modal'
                  type='button'
                  className='primary-btn'
                  aria-label='Close'
                  onClick={() => onClickSubmit()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewTimeSheet;
